import { useSession } from 'core/hooks/session.hook';
import { ROUTES } from 'modules/navigation/enums/routes.enum';
import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router';
import { AbilityProvider } from '../Can';
// Layout is now lazy-loaded in App.tsx, no need to import here

export interface ILocationState {
    from: {
        pathname: string;
        search: string;
    };
}

interface PrivateRouteProps {
    children: ReactNode;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
    const { isLoggedIn, abilities } = useSession();

    const locationState: ILocationState = {
        from: {
            pathname: location.pathname,
            search: location.search,
        },
    };

    if (!isLoggedIn) {
        return <Navigate to={ROUTES.LOGIN} state={locationState} replace />;
    }

    return <AbilityProvider value={abilities}>{children}</AbilityProvider>;
};
